import React from "react";
import { createPortal } from "react-dom";
import { File, FileUp } from "lucide-react";
import useLabels from "hooks/useLabels";
import { Text } from "design_system";

interface DragDropOverlayProps {
  isVisible: boolean;
}

/**
 * Overlay component that appears when dragging files over the page.
 * Shows a dark background with instructions for drag-and-drop upload.
 */
export const DragDropOverlay: React.FC<DragDropOverlayProps> = ({
  isVisible,
}) => {
  const [labels] = useLabels(
    "features.threads.data-source-selector.drag-drop-overlay"
  );

  if (!isVisible) return null;

  const overlayContent = (
    <div
      className="flex fixed inset-0 justify-center items-center pointer-events-none bg-black/60"
      style={{ zIndex: 9999 }}
    >
      <div className="ml-(--sidebar-width) w-full">
        <div className="flex flex-col gap-4 mx-auto max-w-[300px] text-center text-white">
          <div className="flex relative gap-3 justify-center items-center">
            <File
              size={32}
              className="relative"
              style={{
                transform: "rotate(-15deg)",
                transformOrigin: "center",
              }}
            />
            <FileUp
              size={32}
              className="relative"
              style={{
                transform: "translateY(-6px)",
                transformOrigin: "center",
              }}
            />
            <File
              size={32}
              className="relative"
              style={{
                transform: "rotate(15deg)",
                transformOrigin: "center",
              }}
            />
          </div>
          <Text
            as="h2"
            size="sm"
            weight="medium"
            align="center"
            className="!text-white"
          >
            {labels["title"]}
          </Text>
          <Text
            as="p"
            size="x-sm"
            weight="regular"
            align="center"
            className="!text-white"
          >
            {labels["description"]}
          </Text>
        </div>
      </div>
    </div>
  );

  return createPortal(overlayContent, document.body);
};
